// src/components/shared/modals/AddBookmarkModal.tsx
// Wrapper around UnifiedCourseModal for bookmarked courses.

import UnifiedCourseModal from './UnifiedCourseModal';
import type { BookmarkCourseInput } from '../../../hooks/academicPlan/useBookmarkOperations';

interface BookmarkSubmitInput extends BookmarkCourseInput {
  course_id?: number;
  isPlaceholder?: boolean;
  type?: string;
  placeholderType?: string;
  notes?: string;
  requirements?: Record<string, unknown>;
  gen_ed?: unknown;
  gen_ed_area?: unknown;
  gen_ed_requirements?: unknown;
  [key: string]: unknown;
}

export interface AddBookmarkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddToBookmarks: (bookmarkData: BookmarkCourseInput) => Promise<void> | void;
  academicPlan?: unknown;
}

const AddBookmarkModal = ({
  isOpen,
  onClose,
  onAddToBookmarks,
  academicPlan,
}: AddBookmarkModalProps) => {
  const handleSubmit = async (courseData: Record<string, unknown>): Promise<void> => {
    const data = courseData as BookmarkSubmitInput;
    const bookmarkData: BookmarkSubmitInput = {
      code: data.code ?? '',
      title: data.title,
      credits: data.credits,
      course_id: data.course_id,
      isPlaceholder: data.isPlaceholder || data.type === 'placeholder',
      placeholderType: data.placeholderType,
      notes: data.notes,
      requirements: data.requirements,
      gen_ed: data.gen_ed,
      gen_ed_area: data.gen_ed_area,
      gen_ed_requirements: data.gen_ed_requirements,
    };

    await onAddToBookmarks(bookmarkData);
  };

  return (
    <UnifiedCourseModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      context="bookmark"
      academicPlan={academicPlan as never}
    />
  );
};

export default AddBookmarkModal;
